// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1IgM0","header":"MergedInvoice_header__3P2nP"};